module.exports = __webpack_public_path__ + "img/system_4_1.45992674.png";